export * from './module'
var main = require('./module.js');
window.CremagestCore = main;
export default main;